import type { LandingConfig } from "../components/SeoLandingPage";

/* 2027 festival date pages (division C2 of the growth plan, 2026-10-30).
   The "X 2027 kab hai" queries build volume a full year early and the pages
   are evergreen: refresh timings as panchang publishers release them.

   DATES ARE VERIFIED, 2026-10-30, against multiple panchang publishers
   (DrikPanchang + CalendarLabs + devdarsha + panchangdarshan); where
   publishers split (Makar Sankranti, Karwa Chauth) the page SAYS SO rather
   than picking a side silently. Batch 1 gives NO specific puja timings:
   2027 city timings are not reliably published yet, so every page points to
   /panchang for timings closer to the date. Do not add timings here without
   a verified source.

   Batch 2 (2026-11-03: Ganesh Chaturthi, Dussehra, Chhath, Guru Purnima,
   Akshaya Tritiya, Ram Navami, Basant Panchami) verified against DrikPanchang
   year=2027 pages + DekhoPanchang (+ BhaktiBharat, Daanyam where noted). These
   DO quote DrikPanchang's own New Delhi timings, labelled as such; nothing else. */

const planChips = [
  { to: "/panchang", label: "Panchang" },
  { to: "/muhurat", label: "Muhurat" },
  { to: "/free-kundli", label: "Free kundli" },
  { to: "/hi", label: "Hindi rashifal" },
];

export const diwali2027: LandingConfig = {
  url: "https://astroaura.ai/diwali-2027",
  wide: true,
  title: "Diwali 2027 Kab Hai: Date, Day Aur Panchang | Aura AI",
  description:
    "Diwali 2027 Friday, 29 October ko hai. Dhanteras Wednesday 27 October. Kartik Amavasya ki raat Lakshmi Puja hoti hai; date, tithi aur planning ki puri jaankari.",
  eyebrow: "Diwali 2027",
  h1Pre: "Diwali 2027:",
  h1Accent: "Friday, 29 October",
  sub: "Agle saal ki Diwali ek Friday ko hai, long weekend ke saath. Yahan hai pura 5-din ka calendar, tithi ka hisaab, aur apne chart ke hisaab se planning.",
  primaryCta: "Apna free kundli banaiye",
  secondaryCta: "Panchang dekhiye",
  lede: [
    "Diwali 2027, yaani Lakshmi Puja, Friday, 29 October 2027 ko hai. Dhanteras Wednesday, 27 October ko padta hai, aur bhai dooj ke saath yeh 5-din ka utsav November ki shuruaat tak chalta hai. Date Kartik Amavasya se tay hoti hai: jis din suryast ke samay Amavasya tithi ho, usi shaam Lakshmi Puja hoti hai.",
  ],
  heroFacts: ["Friday, 29 Oct 2027", "Dhanteras: Wed, 27 Oct", "Kartik Amavasya"],
  sections: [
    {
      h2: "Diwali 2027 ka 5-din ka calendar",
      table: {
        head: ["Din", "Parv", "Date 2027"],
        rows: [
          ["Day 1", "Dhanteras", "Wednesday, 27 October"],
          ["Day 2", "Naraka Chaturdashi (Choti Diwali)", "Thursday, 28 October"],
          ["Day 3", "Diwali / Lakshmi Puja", "Friday, 29 October"],
          ["Day 4", "Govardhan Puja", "Saturday, 30 October"],
          ["Day 5", "Bhai Dooj", "Sunday, 31 October"],
        ],
        caption:
          "Govardhan aur Bhai Dooj ki exact dates tithi ke overlap par ek din aage-peechhe ho sakti hain; final panchang 2027 me confirm hoga.",
      },
      body: [
        "2027 me Diwali Friday ko padne se Dhanteras se Bhai Dooj tak ka pura utsav ek natural long weekend ban jaata hai. Shaadi-vivah ka season bhi iske turant baad Devuthani Ekadashi se khulta hai.",
      ],
    },
    {
      h2: "Date kaise tay hoti hai: Kartik Amavasya ka niyam",
      body: [
        "Diwali hamesha Kartik month ki Amavasya ko hoti hai, aur Lakshmi Puja us shaam ki jaati hai jab pradosh kaal (suryast ke baad ka samay) me Amavasya tithi maujood ho. Isiliye kabhi-kabhi do calendars me ek din ka antar dikh jaata hai: tithi ka gyan hi asli jawaab hai, printed date nahi.",
        "2027 ke exact Lakshmi Puja muhurat city-wise hum panchang par date ke kareeb publish karenge; abhi se koi bhi minute-level timing likhna andaaza hoga, aur andaaze hum nahi dete.",
      ],
      chips: planChips,
    },
    {
      h2: "Abhi se planning: apne chart ke saath",
      body: [
        "Diwali sirf ek date nahi, ek muhurat-season hai: gold kharidna, naya business shuru karna, griha pravesh. In sab ke liye sahi din aapki apni kundli par depend karta hai. Free kundli banaiye, aur jab 2027 ke muhurat publish hon, to apne chart ke hisaab se din chuniye.",
      ],
    },
  ],
  faqs: [
    {
      q: "Diwali 2027 kab hai?",
      a: "Friday, 29 October 2027 ko. Lakshmi Puja usi shaam hoti hai, kyunki pradosh kaal me Kartik Amavasya tithi rehti hai.",
    },
    {
      q: "Dhanteras 2027 kab hai?",
      a: "Wednesday, 27 October 2027 ko, Diwali se do din pehle.",
    },
    {
      q: "Kya 2027 me Diwali par long weekend banega?",
      a: "Haan, Lakshmi Puja Friday ko hai, to weekend ke saath milakar Dhanteras (Wednesday) se Bhai Dooj (Sunday) tak pura utsav lagatar manaya ja sakega.",
    },
  ],
  schemaName: "Diwali 2027 Date",
  schemaDescription:
    "Diwali 2027 is on Friday, 29 October (Lakshmi Puja), with Dhanteras on Wednesday, 27 October. Five-day calendar and tithi explanation.",
  finalHeading: "2027 ki taiyari, apne chart se",
  finalText:
    "Free kundli banaiye aur festival season ke bade faisle apne grahon ke hisaab se kijiye.",
  articleSection: "Festivals",
};

export const holi2027: LandingConfig = {
  url: "https://astroaura.ai/holi-2027",
  wide: true,
  title: "Holi 2027 Kab Hai: Date, Holika Dahan Aur Panchang | Aura AI",
  description:
    "Holi 2027 Monday, 22 March ko hai; Holika Dahan Sunday, 21 March ki shaam. Phalgun Purnima ka hisaab, regional antar, aur date ki puri jaankari.",
  eyebrow: "Holi 2027",
  h1Pre: "Holi 2027:",
  h1Accent: "Monday, 22 March",
  sub: "Rangwali Holi Monday ko, Holika Dahan ek shaam pehle. Phalgun Purnima se date kaise nikalti hai, aur kahan ek din ka antar ho sakta hai.",
  primaryCta: "Apna free kundli banaiye",
  secondaryCta: "Panchang dekhiye",
  lede: [
    "Holi 2027 me Rangwali Holi (Dhulandi) Monday, 22 March 2027 ko hai, aur Holika Dahan ek shaam pehle, Sunday, 21 March ko. Kuchh regional calendars me Holi 23 March bhi likhi milti hai, kyunki Purnima tithi ka ant kis samay hota hai is par pradesh-dar-pradesh parampara alag hai; zyadaatar panchang 22 March par sehmat hain.",
  ],
  heroFacts: ["Rangwali Holi: Mon, 22 Mar 2027", "Holika Dahan: Sun, 21 Mar", "Phalgun Purnima"],
  sections: [
    {
      h2: "Holika Dahan ka niyam",
      body: [
        "Holika Dahan Phalgun Purnima ki raat, pradosh kaal me, Bhadra ke samaapt hone ke baad kiya jaata hai. Isi Bhadra-niyam ki wajah se dahan ka exact muhurat har saal alag hota hai aur city ke hisaab se badalta hai. 2027 ke dahan muhurat hum date ke kareeb panchang par denge.",
        "Agli subah rang khelte hain, use Dhulandi ya Rangwali Holi kehte hain.",
      ],
      chips: planChips,
    },
    {
      h2: "22 ya 23 March: antar kyun dikhta hai",
      body: [
        "Jab Purnima tithi do dinon par fail jaati hai, to kuch parampara dahan ke agle din rang khelti hain aur kuch tithi-ant waale din. 2027 me adhiktar publishers ne 21 March dahan aur 22 March Holi likhi hai; apne sheher ke sthaniya panchang se confirm karna hamesha sahi rehta hai.",
      ],
    },
  ],
  faqs: [
    { q: "Holi 2027 kab hai?", a: "Rangwali Holi Monday, 22 March 2027 ko hai." },
    { q: "Holika Dahan 2027 kab hai?", a: "Sunday, 21 March 2027 ki shaam ko, Bhadra samaapt hone ke baad pradosh kaal me." },
    { q: "Kya Holi 23 March ko bhi ho sakti hai?", a: "Kuchh regional calendars me haan, kyunki Purnima tithi ka ant alag samay par maana jaata hai. Zyadaatar panchang 22 March par sehmat hain; apna sthaniya panchang dekhiye." },
  ],
  schemaName: "Holi 2027 Date",
  schemaDescription:
    "Holi 2027: Rangwali Holi on Monday, 22 March; Holika Dahan on Sunday, 21 March. How the Phalgun Purnima rule sets the date.",
  finalHeading: "Festival season, apne chart ke saath",
  finalText: "Free kundli banaiye aur saal bhar ke parv apne grahon ke hisaab se plan kijiye.",
  articleSection: "Festivals",
};

export const rakshaBandhan2027: LandingConfig = {
  url: "https://astroaura.ai/raksha-bandhan-2027",
  wide: true,
  title: "Raksha Bandhan 2027 Kab Hai: Date Aur Bhadra Niyam | Aura AI",
  description:
    "Raksha Bandhan 2027 Tuesday, 17 August ko hai, Shravan Purnima par. Rakhi bandhne ka samay Bhadra ke baad hota hai; pura niyam aur planning yahan.",
  eyebrow: "Raksha Bandhan 2027",
  h1Pre: "Raksha Bandhan 2027:",
  h1Accent: "Tuesday, 17 August",
  sub: "Rakhi ka tyohaar Shravan Purnima ko manaya jaata hai, aur rakhi hamesha Bhadra samaapt hone ke baad baandhi jaati hai.",
  primaryCta: "Apna free kundli banaiye",
  secondaryCta: "Panchang dekhiye",
  lede: [
    "Raksha Bandhan 2027 Tuesday, 17 August 2027 ko hai. Date Shravan month ki Purnima se tay hoti hai. Rakhi baandhne ka shubh samay us din Bhadra kaal ke baad shuru hota hai; 2027 ka exact Bhadra-ant samay hum date ke kareeb panchang par denge, kyunki woh city aur tithi-gati par depend karta hai.",
  ],
  heroFacts: ["Tuesday, 17 Aug 2027", "Shravan Purnima", "Rakhi: Bhadra ke baad"],
  sections: [
    {
      h2: "Bhadra me rakhi kyun nahi bandhte",
      body: [
        "Parampara me Bhadra kaal ko rakhi, Holika Dahan jaise kaamon ke liye varjit maana gaya hai. Isliye har saal 'rakhi ka muhurat' asal me 'Bhadra kab khatam hoti hai' ka jawaab hota hai. Kabhi Bhadra subah hi nikal jaati hai aur pura din shubh rehta hai; kabhi dopahar tak rukna padta hai.",
      ],
      chips: planChips,
    },
    {
      h2: "NRI bhai-behen: time zone ka dhyaan",
      body: [
        "Agar bhai ya behen videsh me hai, to muhurat wahan ke LOCAL panchang se dekha jaata hai, India ke samay se convert karke nahi. Humara panchang city chunne par wahi ka samay dikhata hai, isliye US ya Gulf me baithe parivaar ke liye bhi sahi window milti hai.",
      ],
    },
  ],
  faqs: [
    { q: "Raksha Bandhan 2027 kab hai?", a: "Tuesday, 17 August 2027 ko, Shravan Purnima par." },
    { q: "Rakhi kis samay bandhni chahiye?", a: "Bhadra kaal samaapt hone ke baad. 2027 ka exact samay city ke hisaab se panchang par date ke kareeb milega." },
    { q: "Kya Raksha Bandhan ki date India aur US me alag ho sakti hai?", a: "Tithi ka samay time zone ke hisaab se shift hota hai, isliye kabhi-kabhi observance ka din alag pad sakta hai. Apne sheher ka panchang dekhna sabse sahi tarika hai." },
  ],
  schemaName: "Raksha Bandhan 2027 Date",
  schemaDescription:
    "Raksha Bandhan 2027 is on Tuesday, 17 August, on Shravan Purnima. Rakhi is tied after Bhadra ends; timing published closer to the date.",
  finalHeading: "Parivaar ke parv, bina confusion ke",
  finalText: "Free kundli aur panchang ke saath har tyohaar ka sahi samay janiye.",
  articleSection: "Festivals",
};

export const navratri2027: LandingConfig = {
  url: "https://astroaura.ai/navratri-2027",
  wide: true,
  title: "Navratri 2027 Kab Se Hai: Dates Aur Ghatasthapana | Aura AI",
  description:
    "Sharad Navratri 2027 Thursday, 30 September se shuru hokar Dussehra Saturday, 9 October tak chalti hai. Chaitra Navratri April me. Puri date list yahan.",
  eyebrow: "Navratri 2027",
  h1Pre: "Sharad Navratri 2027:",
  h1Accent: "30 September se 9 October",
  sub: "Ghatasthapana Thursday, 30 September ko; Vijayadashami (Dussehra) Saturday, 9 October ko. Chaitra Navratri April 2027 me alag se aati hai.",
  primaryCta: "Apna free kundli banaiye",
  secondaryCta: "Panchang dekhiye",
  lede: [
    "Sharad Navratri 2027 Thursday, 30 September 2027 ko Ghatasthapana ke saath shuru hoti hai aur Vijayadashami yaani Dussehra Saturday, 9 October 2027 ko manaya jaata hai. Saal ki doosri badi Navratri, Chaitra Navratri, 7 April 2027 se shuru hokar Ram Navami (15 April) tak chalti hai.",
  ],
  heroFacts: ["Ghatasthapana: Thu, 30 Sep 2027", "Dussehra: Sat, 9 Oct 2027", "Chaitra Navratri: 7-15 Apr"],
  sections: [
    {
      h2: "Navratri 2027 ki मुख्य dates",
      table: {
        head: ["Parv", "Date 2027"],
        rows: [
          ["Ghatasthapana (Day 1)", "Thursday, 30 September"],
          ["Durga Ashtami", "around 7-8 October (tithi par depend)"],
          ["Maha Navami", "around 8 October"],
          ["Vijayadashami / Dussehra", "Saturday, 9 October"],
        ],
        caption:
          "Ashtami-Navami ki exact dates tithi ke overlap par tay hoti hain; final din 2027 ke panchang se confirm hoga.",
      },
      chips: planChips,
    },
    {
      h2: "Ghatasthapana ka muhurat",
      body: [
        "Ghatasthapana Pratipada tithi me, Abhijit muhurat ya pratah-kaal ke shubh window me ki jaati hai, aur yeh window city ke hisaab se badalti hai. 2027 ke city-wise muhurat hum date ke kareeb panchang par publish karenge.",
        "Navratri ke nau din naye kaam, saadhana aur upvaas ke liye shubh maane jaate hain, aur iske theek baad Diwali season shuru ho jaata hai: 2027 me Diwali 29 October ko hai.",
      ],
    },
  ],
  faqs: [
    { q: "Navratri 2027 kab se shuru hai?", a: "Sharad Navratri Thursday, 30 September 2027 se, Ghatasthapana ke saath." },
    { q: "Dussehra 2027 kab hai?", a: "Saturday, 9 October 2027 ko Vijayadashami manayi jaayegi." },
    { q: "Chaitra Navratri 2027 kab hai?", a: "7 April 2027 se, Ram Navami 15 April ko." },
  ],
  schemaName: "Navratri 2027 Dates",
  schemaDescription:
    "Sharad Navratri 2027 runs 30 September to Dussehra on 9 October; Chaitra Navratri runs 7-15 April 2027.",
  finalHeading: "Nau din, apne chart ke saath",
  finalText: "Free kundli banaiye aur Navratri ki saadhana apne grahon ke hisaab se kijiye.",
  articleSection: "Festivals",
};

export const mahaShivratri2027: LandingConfig = {
  url: "https://astroaura.ai/maha-shivratri-2027",
  wide: true,
  title: "Maha Shivratri 2027 Kab Hai: Date Aur Vrat Niyam | Aura AI",
  description:
    "Maha Shivratri 2027 Saturday, 6 March ko hai, Phalgun Krishna Chaturdashi par. Raat ke chaar prahar ki puja ka niyam aur date ka hisaab yahan.",
  eyebrow: "Maha Shivratri 2027",
  h1Pre: "Maha Shivratri 2027:",
  h1Accent: "Saturday, 6 March",
  sub: "Shiv bhakti ki sabse badi raat, is baar Saturday ko. Date Phalgun Krishna Chaturdashi se tay hoti hai aur puja raat ke chaar praharon me hoti hai.",
  primaryCta: "Apna free kundli banaiye",
  secondaryCta: "Panchang dekhiye",
  lede: [
    "Maha Shivratri 2027 Saturday, 6 March 2027 ko hai. Yeh vrat Phalgun month ki Krishna Chaturdashi ko rakha jaata hai, aur puja us raat ke chaar praharon me ki jaati hai, jinke samay har sheher me alag hote hain. 2027 ke prahar-wise samay hum date ke kareeb panchang par denge.",
  ],
  heroFacts: ["Saturday, 6 Mar 2027", "Phalgun Krishna Chaturdashi", "Raat ke 4 prahar"],
  sections: [
    {
      h2: "Shivratri ki raat ka niyam",
      body: [
        "Maha Shivratri ki puja nishita kaal (aadhi raat ke aas-paas) me sabse phal-dayak maani jaati hai, aur vrat agli subah Chaturdashi tithi ke bhitar paaran karke khola jaata hai. Isliye sirf date nahi, raat ke prahar ka samay bhi mahatvapurna hai.",
      ],
      chips: planChips,
    },
    {
      h2: "Jyotish me Shivratri",
      body: [
        "Shivratri Chandra ke sabse ksheen hone ki raat ke paas aati hai: man (Chandra) ko saadhna ki raat. Jinke chart me Chandra kamzor ho ya Shani ki dasha chal rahi ho, unke liye parampara me is vrat ka vishesh mahatva bataya gaya hai. Apni dasha janne ke liye free kundli banaiye.",
      ],
    },
  ],
  faqs: [
    { q: "Maha Shivratri 2027 kab hai?", a: "Saturday, 6 March 2027 ko." },
    { q: "Puja ka sabse accha samay kaunsa hai?", a: "Nishita kaal, yaani aadhi raat ke aas-paas ka muhurat. City-wise samay 2027 me panchang par milega." },
    { q: "Vrat kab khola jaata hai?", a: "Agli subah, Chaturdashi tithi samaapt hone se pehle paaran karke." },
  ],
  schemaName: "Maha Shivratri 2027 Date",
  schemaDescription:
    "Maha Shivratri 2027 is on Saturday, 6 March, on Phalgun Krishna Chaturdashi, with night-long prahar puja.",
  finalHeading: "Saadhana, apne chart ke hisaab se",
  finalText: "Free kundli se apni dasha janiye aur vrat-tyohaar sahi samay par kijiye.",
  articleSection: "Festivals",
};

export const janmashtami2027: LandingConfig = {
  url: "https://astroaura.ai/janmashtami-2027",
  wide: true,
  title: "Janmashtami 2027 Kab Hai: Date Aur Rohini Nakshatra | Aura AI",
  description:
    "Krishna Janmashtami 2027 Wednesday, 25 August ko hai, Bhadrapada Krishna Ashtami par. Rohini nakshatra ka sanyog aur madhyaratri puja ka niyam yahan.",
  eyebrow: "Janmashtami 2027",
  h1Pre: "Janmashtami 2027:",
  h1Accent: "Wednesday, 25 August",
  sub: "Krishna janm ki raat: Bhadrapada Krishna Ashtami, madhyaratri ki puja, aur Rohini nakshatra ka vishesh sanyog.",
  primaryCta: "Apna free kundli banaiye",
  secondaryCta: "Panchang dekhiye",
  lede: [
    "Krishna Janmashtami 2027 Wednesday, 25 August 2027 ko hai. Vrat Bhadrapada (kuchh paramparaon me Shravan) ki Krishna Ashtami ko rakha jaata hai, aur janmotsav madhyaratri ko manaya jaata hai, kyunki Krishna ka janm aadhi raat ka maana gaya hai. Jis saal Ashtami ke saath Rohini nakshatra bhi mil jaaye, us sanyog ko sabse shubh kaha jaata hai.",
  ],
  heroFacts: ["Wednesday, 25 Aug 2027", "Bhadrapada Krishna Ashtami", "Madhyaratri puja"],
  sections: [
    {
      h2: "Smart aur Vaishnav parampara ka antar",
      body: [
        "Kai saal Janmashtami do dinon par manayi jaati hai: grihasth (Smart) parampara Ashtami-madhyaratri ke hisaab se, aur Vaishnav parampara udaya-tithi ke hisaab se agle din. 2027 ki final parampara-wise dates hum panchang par date ke kareeb confirm karenge.",
      ],
      chips: planChips,
    },
    {
      h2: "Jyotish me Janmashtami",
      body: [
        "Rohini Chandra ka sabse priya nakshatra maana jaata hai, isliye Ashtami + Rohini ka sanyog itna mahatvapurna hai. Apna janm-nakshatra janna ho to free kundli me turant dikh jaata hai, Krishna ki tarah aapka bhi ek janm-nakshatra hai.",
      ],
    },
  ],
  faqs: [
    { q: "Janmashtami 2027 kab hai?", a: "Wednesday, 25 August 2027 ko." },
    { q: "Puja kis samay hoti hai?", a: "Madhyaratri (nishita kaal) me, kyunki Krishna janm aadhi raat ka maana gaya hai. City-wise samay panchang par milega." },
    { q: "Dahi handi kab hoti hai?", a: "Zyadaatar jagah janmotsav ke agle din, yaani 26 August 2027 ke aas-paas." },
  ],
  schemaName: "Janmashtami 2027 Date",
  schemaDescription:
    "Krishna Janmashtami 2027 is on Wednesday, 25 August, on Bhadrapada Krishna Ashtami, with midnight puja.",
  finalHeading: "Apna janm-nakshatra janiye",
  finalText: "Free kundli me apna nakshatra, lagna aur dasha turant dekhiye.",
  articleSection: "Festivals",
};

export const makarSankranti2027: LandingConfig = {
  url: "https://astroaura.ai/makar-sankranti-2027",
  wide: true,
  title: "Makar Sankranti 2027 Kab Hai: 14 Ya 15 January? | Aura AI",
  description:
    "Makar Sankranti 2027 Friday, 15 January ko hai; sankranti ka kshan ek raat pehle padta hai, isliye kuchh calendar 14 January likhte hain. Pura hisaab yahan.",
  eyebrow: "Makar Sankranti 2027",
  h1Pre: "Makar Sankranti 2027:",
  h1Accent: "Friday, 15 January",
  sub: "Surya ka Makar rashi me pravesh: is baar sankranti ka kshan raat me padta hai, isliye punya kaal agle din, 15 January ko manaya jaayega.",
  primaryCta: "Apna free kundli banaiye",
  secondaryCta: "Panchang dekhiye",
  lede: [
    "Makar Sankranti 2027 Friday, 15 January 2027 ko manayi jaayegi. Surya ka Makar rashi me pravesh (sankranti ka kshan) 14 January ki raat ko hota hai, aur niyam ke anusaar jab sankranti suryast ke baad ho, to punya kaal agle din manaya jaata hai. Isi wajah se kuchh calendars me 14 January bhi chhapa milta hai.",
  ],
  heroFacts: ["Friday, 15 Jan 2027", "Surya ka Makar pravesh", "Pongal / Uttarayan season"],
  sections: [
    {
      h2: "14 ya 15: confusion ka asli karan",
      body: [
        "Makar Sankranti tithi se nahi, SURYA ke rashi-parivartan ke kshan se tay hoti hai, isliye yeh har saal lagbhag ek hi date par aati hai. Jab pravesh ka kshan raat me padta hai, to snan-daan ka punya kaal agli subah gina jaata hai. 2027 me isi niyam se 15 January observance ka din hai.",
      ],
      chips: planChips,
    },
    {
      h2: "Ek hi din, kai naam",
      bullets: [
        "Pongal (Tamil Nadu): 2027 me isi window me, fasal ka utsav.",
        "Uttarayan (Gujarat): patang ka din.",
        "Magh/Bhogali Bihu (Assam) aur Maghi (Punjab): isi surya-parv ke roop.",
      ],
      body: [
        "Jyotish me Makar Sankranti se Surya uttarayan ki or badhta maana jaata hai, shubh kaamon ka season khulta hai. Apne chart me Surya kahan hai, free kundli me dekhiye.",
      ],
    },
  ],
  faqs: [
    { q: "Makar Sankranti 2027 kab hai?", a: "Friday, 15 January 2027 ko. Sankranti ka kshan 14 January ki raat padta hai, isliye punya kaal 15 ko hai." },
    { q: "Kuchh calendar 14 January kyun likhte hain?", a: "Kyunki surya ka Makar pravesh 14 ki raat hota hai. Observance ka niyam raat ke pravesh par agle din punya kaal deta hai." },
    { q: "Pongal 2027 kab hai?", a: "Isi window me, 15 January 2027 ke aas-paas Thai Pongal manaya jaayega." },
  ],
  schemaName: "Makar Sankranti 2027 Date",
  schemaDescription:
    "Makar Sankranti 2027 is observed on Friday, 15 January; the solar ingress falls the previous night, which is why some calendars print 14 January.",
  finalHeading: "Surya ka parv, apne chart me",
  finalText: "Free kundli me dekhiye Surya aapke kis ghar me hai aur kya deta hai.",
  articleSection: "Festivals",
};

export const karwaChauth2027: LandingConfig = {
  url: "https://astroaura.ai/karwa-chauth-2027",
  wide: true,
  title: "Karwa Chauth 2027 Kab Hai: 18 Ya 19 October? | Aura AI",
  description:
    "Karwa Chauth 2027 zyaadatar panchang Monday, 18 October dete hain; kuchh city-panchang Tuesday, 19 October. Kartik Krishna Chaturthi ka hisaab yahan.",
  eyebrow: "Karwa Chauth 2027",
  h1Pre: "Karwa Chauth 2027:",
  h1Accent: "Monday, 18 October",
  sub: "Suhagan ka vrat Kartik Krishna Chaturthi ko: 2027 me tithi do dinon par fail rahi hai, isliye 18 aur 19 October dono chapte hain. Pura hisaab neeche.",
  primaryCta: "Apna free kundli banaiye",
  secondaryCta: "Panchang dekhiye",
  lede: [
    "Karwa Chauth 2027 ke liye zyaadatar panchang, DrikPanchang samet, Monday, 18 October 2027 dete hain; kuchh city-panchang Tuesday, 19 October likhte hain. Antar isliye hai ki vrat ka din us city ke suryoday ke samay Chaturthi tithi aur chandrodaya, dono par depend karta hai. Apne sheher ka final din 2027 me sthaniya panchang se confirm kijiye, aur yeh page bhi hum updated rakhenge.",
  ],
  heroFacts: ["Mon, 18 Oct 2027 (zyaadatar panchang)", "Kartik Krishna Chaturthi", "Chandrodaya par vrat-paaran"],
  sections: [
    {
      h2: "18 ya 19: sahi din kaise chuna jaata hai",
      body: [
        "Vrat ka din woh hota hai jis din chandrodaya ke samay Chaturthi tithi maujood ho. Tithi jab do calendar-dinon par failti hai, to alag-alag shehron me chandrodaya ke samay ke hisaab se din badal sakta hai, isliye Delhi aur Chennai ke panchang alag jawaab de sakte hain, aur dono sahi hote hain.",
      ],
      chips: planChips,
    },
    {
      h2: "Vrat ka din: kya-kya hota hai",
      steps: [
        "Suryoday se pehle sargi (saas ki di hui) ke saath vrat shuru.",
        "Din bhar nirjala vrat; shaam ko Karwa Mata ki katha.",
        "Chandrodaya par chhalni se chandra-darshan aur pati ka chehra; phir paaran.",
      ],
      body: [
        "Chandrodaya ka samay city-dar-city 30-60 minute tak alag hota hai. 2027 ke city-wise moonrise hum panchang par date ke kareeb denge, jaise is saal ke Karwa Chauth guide me diye the.",
      ],
    },
  ],
  faqs: [
    { q: "Karwa Chauth 2027 kab hai?", a: "Adhikaansh panchang Monday, 18 October 2027 dete hain; kuchh city-panchang 19 October. Final din apne sheher ke panchang se confirm kijiye." },
    { q: "Vrat ka niyam kis tithi se juda hai?", a: "Kartik month ki Krishna Chaturthi se, aur us din ke chandrodaya se." },
    { q: "Chand kitne baje niklega?", a: "2027 ke city-wise chandrodaya samay hum date ke kareeb panchang par publish karenge; abhi se minute-level samay dena andaaza hoga." },
  ],
  schemaName: "Karwa Chauth 2027 Date",
  schemaDescription:
    "Karwa Chauth 2027: most panchangs list Monday, 18 October; some city panchangs list 19 October because the Chaturthi tithi spans two days. The rule and how to confirm locally.",
  finalHeading: "Vrat aur muhurat, bina guesswork ke",
  finalText: "Panchang par apne sheher ka samay dekhiye aur kundli se apna chandra janiye.",
  articleSection: "Festivals",
};

const datesDisclaimer =
  "Dates aur timings DrikPanchang ke 2027 panchang (New Delhi) aur doosre publishers se mila kar likhe gaye hain. Sthaniya parampara aur sheher ke hisaab se antar ho sakta hai; vrat ya puja se pehle apne sthaniya panchang ya purohit se confirm kijiye.";

export const ganeshChaturthi2027: LandingConfig = {
  url: "https://astroaura.ai/ganesh-chaturthi-2027",
  wide: true,
  title: "Ganesh Chaturthi 2027 Kab Hai: Date Aur Muhurat | Aura AI",
  description:
    "Ganesh Chaturthi 2027 Saturday, 4 September ko hai; visarjan Tuesday, 14 September. Madhyahna puja muhurat, Chaturthi tithi aur chandra darshan ka niyam yahan.",
  eyebrow: "Ganesh Chaturthi 2027",
  h1Pre: "Ganesh Chaturthi 2027:",
  h1Accent: "Saturday, 4 September",
  sub: "Bappa ka aagman Saturday ko, Anant Chaturdashi par visarjan Tuesday, 14 September ko. Madhyahna puja ka samay aur chand na dekhne ka niyam neeche.",
  primaryCta: "Apna free kundli banaiye",
  secondaryCta: "Panchang dekhiye",
  lede: [
    "Ganesh Chaturthi 2027 Saturday, 4 September 2027 ko hai. Yeh parv Bhadrapada Shukla Chaturthi ko manaya jaata hai, aur Ganesh sthapana madhyahna (dopahar) me ki jaati hai, kyunki Ganesh ji ka janm madhyahna ka maana gaya hai. Das din ka Ganeshotsav Anant Chaturdashi, Tuesday, 14 September 2027 ko visarjan ke saath poora hota hai.",
  ],
  heroFacts: ["Saturday, 4 Sep 2027", "Visarjan: Tue, 14 Sep", "Bhadrapada Shukla Chaturthi"],
  sections: [
    {
      h2: "Ganesh Chaturthi 2027: tithi aur muhurat (New Delhi)",
      table: {
        head: ["Vivaran", "Samay (New Delhi)"],
        rows: [
          ["Chaturthi tithi shuru", "2:18 PM, Friday, 3 September"],
          ["Chaturthi tithi samaapt", "12:25 PM, Saturday, 4 September"],
          ["Madhyahna Ganesh puja muhurat", "11:04 AM se 12:25 PM, 4 September"],
          ["Chandra darshan se bachein (4 Sep)", "9:45 AM se 8:43 PM"],
          ["Ganesh visarjan (Anant Chaturdashi)", "Tuesday, 14 September"],
        ],
        caption:
          "Samay DrikPanchang ke anusaar, New Delhi ke liye. Doosre sheher me yeh minute badal jaate hain; apne sheher ka samay panchang par dekhiye.",
      },
      body: [
        "DrikPanchang ka puja muhurat 12:25 PM par isliye khatam hota hai kyunki usi samay Chaturthi tithi samaapt hoti hai. Kuchh publishers (jaise DekhoPanchang) poore madhyahna ka window, 11:04 AM se 1:36 PM, dete hain. Agar aap tithi ke bhitar sthapana chahte hain, to 12:25 PM se pehle karna surakshit hai.",
      ],
      chips: planChips,
    },
    {
      h2: "Chand kyun nahi dekhte: Kalank Chaturthi",
      body: [
        "Parampara ke anusaar Ganesh Chaturthi ki raat chandra darshan karne se mithya kalank (jhootha aarop) lagta hai, isliye ise Kalank Chaturthi bhi kehte hain. 2027 me DrikPanchang New Delhi ke liye 3 September ko 2:18 PM se 8:06 PM aur 4 September ko 9:45 AM se 8:43 PM tak chand dekhne se bachne ko kehta hai.",
        "Galti se chand dikh jaaye to parampara me Syamantaka mani ki katha sunne ka upay bataya gaya hai.",
      ],
    },
    {
      h2: "Dedh, teen, paanch ya das din: visarjan ke vikalp",
      body: [
        "Ganesh sthapana ke baad kai parivaar 1.5, 3, 5 ya 7 din me visarjan karte hain, aur sarvajanik pandal zyaadatar das din baad Anant Chaturdashi par. 2027 me Anant Chaturdashi Tuesday, 14 September ko hai; DrikPanchang ke anusaar Chaturdashi tithi 14 September ko 12:39 AM se 15 September ko 2:48 AM tak (New Delhi) rahegi.",
        "Naya kaam, griha pravesh ya vyapaar shuru karne ke liye Ganesh Chaturthi ko shubh maana jaata hai, par sahi din aapki kundli par bhi depend karta hai. Free kundli banaiye aur muhurat apne chart ke hisaab se chuniye.",
      ],
    },
  ],
  faqs: [
    { q: "Ganesh Chaturthi 2027 kab hai?", a: "Saturday, 4 September 2027 ko, Bhadrapada Shukla Chaturthi par." },
    { q: "Ganesh sthapana ka muhurat kya hai?", a: "DrikPanchang ke anusaar New Delhi me madhyahna puja muhurat 11:04 AM se 12:25 PM tak hai. Doosre sheher ka samay panchang par dekhiye." },
    { q: "Ganesh visarjan 2027 kab hai?", a: "Das din ka utsav Anant Chaturdashi, Tuesday, 14 September 2027 ko visarjan ke saath poora hota hai." },
    { q: "Kya Ganesh Chaturthi par chand dekh sakte hain?", a: "Parampara me nahi. New Delhi me 4 September ko 9:45 AM se 8:43 PM tak chandra darshan se bachne ko kaha gaya hai (DrikPanchang)." },
  ],
  schemaName: "Ganesh Chaturthi 2027 Date",
  schemaDescription:
    "Ganesh Chaturthi 2027 is on Saturday, 4 September (Bhadrapada Shukla Chaturthi), with Ganesh Visarjan on Anant Chaturdashi, Tuesday, 14 September. New Delhi puja muhurat per DrikPanchang.",
  finalHeading: "Shubh aarambh, apne chart ke saath",
  finalText: "Free kundli banaiye aur naye kaam ka muhurat apne grahon ke hisaab se chuniye.",
  disclaimer: datesDisclaimer,
  articleSection: "Festivals",
};

export const dussehra2027: LandingConfig = {
  url: "https://astroaura.ai/dussehra-2027",
  wide: true,
  title: "Dussehra 2027 Kab Hai: 9 Ya 10 October? | Aura AI",
  description:
    "Dussehra 2027 zyaadatar panchang Saturday, 9 October dete hain; kuchh calendar 10 October. Vijay muhurat, Dashami tithi aur dono dates ka karan yahan.",
  eyebrow: "Dussehra 2027",
  h1Pre: "Dussehra 2027:",
  h1Accent: "Saturday, 9 October",
  sub: "Vijayadashami Ashwin Shukla Dashami ko: 2027 me tithi do dinon par fail rahi hai, isliye 9 aur 10 October dono chapte hain. Pura hisaab neeche.",
  primaryCta: "Apna free kundli banaiye",
  secondaryCta: "Panchang dekhiye",
  lede: [
    "Dussehra yaani Vijayadashami 2027 ke liye DrikPanchang aur DekhoPanchang, dono Saturday, 9 October 2027 dete hain, kyunki us din aparahna (dopahar baad) me Dashami tithi maujood hai. Kuchh calendar, jo suryoday ke samay ki tithi se din chunte hain, Sunday, 10 October likhte hain, aur Bengal ki parampara me Vijayadashami bhi 10 October ko hai. Sharad Navratri 30 September se shuru hoti hai.",
  ],
  heroFacts: ["Sat, 9 Oct 2027 (zyaadatar panchang)", "Ashwin Shukla Dashami", "Vijay muhurat: 2:05 PM (Delhi)"],
  sections: [
    {
      h2: "Dussehra 2027: tithi aur Vijay muhurat (New Delhi)",
      table: {
        head: ["Vivaran", "Samay (New Delhi)"],
        rows: [
          ["Dashami tithi shuru", "9:01 AM, Saturday, 9 October"],
          ["Dashami tithi samaapt", "11:40 AM, Sunday, 10 October"],
          ["Vijay muhurat", "2:05 PM se 2:52 PM, 9 October"],
          ["Shravana nakshatra", "10:17 AM, 9 Oct se 1:25 PM, 10 Oct"],
        ],
        caption:
          "Samay DrikPanchang ke anusaar, New Delhi ke liye. Doosre sheher ka samay panchang par dekhiye.",
      },
      chips: planChips,
    },
    {
      h2: "9 ya 10 October: antar kyun dikhta hai",
      body: [
        "Dharmasindhu aur Nirnayasindhu jaise granthon ka niyam hai ki Vijayadashami us din manayi jaaye jab aparahna kaal me Dashami tithi ho. 2027 me Dashami 9 October ki subah 9:01 AM par shuru hoti hai, isliye 9 October ki dopahar Dashami me padti hai. Is niyam se 9 October hi Dussehra hai, aur DrikPanchang ka Vijay muhurat bhi isi din ka hai.",
        "Kuchh calendar (jaise Daanyam ka Delhi page) suryoday ki tithi ka niyam lagate hain: 10 October ke suryoday par Dashami hai, isliye woh 10 October likhte hain. Bengal ki Durga Puja parampara me bhi DrikPanchang Vijayadashami 10 October ko deta hai. Dono parampara apni jagah sahi hain; apne mandir ya sthaniya panchang ka paalan kijiye.",
      ],
    },
    {
      h2: "Vijay muhurat aur shubh kaam",
      body: [
        "Dussehra ko saal ke saade teen abujh muhuraton me gina jaata hai, yaani is din bina alag muhurat dekhe naye kaam shuru kiye ja sakte hain. Shastra puja, vahan kharidna aur naya vyapaar is din parampara se kiye jaate hain. Vijay muhurat me kiya gaya kaam vishesh phal-dayak maana jaata hai.",
        "Iske theek baad Diwali season shuru hota hai: 2027 me Diwali 29 October ko hai.",
      ],
    },
  ],
  faqs: [
    { q: "Dussehra 2027 kab hai?", a: "Adhikaansh panchang, DrikPanchang samet, Saturday, 9 October 2027 dete hain. Kuchh calendar aur Bengal parampara 10 October." },
    { q: "Dussehra 2027 ka Vijay muhurat kya hai?", a: "DrikPanchang ke anusaar New Delhi me 2:05 PM se 2:52 PM, 9 October 2027." },
    { q: "Kuchh calendar 10 October kyun likhte hain?", a: "Kyunki 10 October ke suryoday par Dashami tithi hai. Aparahna-niyam se 9 October banta hai, suryoday-niyam se 10 October." },
  ],
  schemaName: "Dussehra 2027 Date",
  schemaDescription:
    "Dussehra (Vijayadashami) 2027: most panchangs list Saturday, 9 October with Vijay Muhurat 2:05 PM to 2:52 PM in New Delhi; sunrise-rule calendars and the Bengal tradition list 10 October.",
  finalHeading: "Vijay ka din, apne chart ke saath",
  finalText: "Free kundli banaiye aur naye aarambh ka sahi samay apne grahon se janiye.",
  disclaimer: datesDisclaimer,
  articleSection: "Festivals",
};

export const chhathPuja2027: LandingConfig = {
  url: "https://astroaura.ai/chhath-puja-2027",
  wide: true,
  title: "Chhath Puja 2027 Kab Hai: 4 Din Ka Calendar | Aura AI",
  description:
    "Chhath Puja 2027 ki Sandhya Arghya Thursday, 4 November ko, Usha Arghya Friday, 5 November. Nahay Khay se paaran tak 4 din ka calendar aur samay yahan.",
  eyebrow: "Chhath Puja 2027",
  h1Pre: "Chhath Puja 2027:",
  h1Accent: "Thursday, 4 November",
  sub: "Nahay Khay Tuesday, 2 November se shuru, Sandhya Arghya Thursday ko aur Usha Arghya ke saath paaran Friday, 5 November ko.",
  primaryCta: "Apna free kundli banaiye",
  secondaryCta: "Panchang dekhiye",
  lede: [
    "Chhath Puja 2027 ka mukhya din, Sandhya Arghya, Thursday, 4 November 2027 ko hai. Yeh Kartik Shukla Shashthi ka parv hai, aur chaar din ka vrat Tuesday, 2 November ko Nahay Khay se shuru hokar Friday, 5 November ko Usha Arghya aur paaran ke saath poora hota hai. Diwali (29 October) ke chhathe din yeh Surya aur Chhathi Maiya ki upasana hai.",
  ],
  heroFacts: ["Sandhya Arghya: Thu, 4 Nov 2027", "Usha Arghya: Fri, 5 Nov", "Kartik Shukla Shashthi"],
  sections: [
    {
      h2: "Chhath Puja 2027 ka 4-din ka calendar",
      table: {
        head: ["Din", "Parv", "Date 2027", "Surya (New Delhi)"],
        rows: [
          ["Day 1", "Nahay Khay", "Tuesday, 2 November", "Suryast 5:35 PM"],
          ["Day 2", "Lohanda aur Kharna", "Wednesday, 3 November", "Suryast 5:35 PM"],
          ["Day 3", "Sandhya Arghya (Chhath Puja)", "Thursday, 4 November", "Suryast 5:34 PM"],
          ["Day 4", "Usha Arghya aur Paaran", "Friday, 5 November", "Suryoday 6:36 AM"],
        ],
        caption:
          "Dates aur suryoday-suryast DrikPanchang ke Chhath calendar se, New Delhi ke liye. Arghya ka samay apne sheher ke suryast-suryoday se dekhiye.",
      },
      chips: planChips,
    },
    {
      h2: "Arghya ka samay kaise tay hota hai",
      body: [
        "Chhath me koi alag muhurat nahi hota: Sandhya Arghya doobte Surya ko suryast ke samay, aur Usha Arghya ugte Surya ko suryoday ke samay diya jaata hai. Isliye har ghaat ka samay us sheher ke suryast-suryoday par depend karta hai. Patna, Delhi aur Mumbai me yeh samay alag hota hai.",
        "DrikPanchang ke anusaar 2027 me Shashthi tithi 3 November ko 7:31 PM se 4 November ko 9:37 PM tak (New Delhi) rahegi, isliye 4 November ki shaam ka arghya Shashthi tithi me hi padta hai. DekhoPanchang aur public holiday calendars bhi Chhath 4 November par dete hain.",
      ],
    },
    {
      h2: "Kharna aur 36 ghante ka nirjala vrat",
      body: [
        "Kharna ki shaam gud ki kheer aur roti ka prasad grahan karne ke baad vrati lagbhag 36 ghante ka nirjala vrat rakhte hain, jo Usha Arghya ke baad paaran se khulta hai. Videsh me rehne wale parivaar apne sheher ke local panchang aur suryoday-suryast se din aur samay dekhein.",
      ],
    },
  ],
  faqs: [
    { q: "Chhath Puja 2027 kab hai?", a: "Mukhya din (Sandhya Arghya) Thursday, 4 November 2027 ko hai. Chaar din ka vrat 2 se 5 November tak chalega." },
    { q: "Nahay Khay aur Kharna 2027 kab hai?", a: "Nahay Khay Tuesday, 2 November aur Kharna Wednesday, 3 November 2027 ko." },
    { q: "Usha Arghya 2027 kab hai?", a: "Friday, 5 November 2027 ki subah suryoday par. New Delhi me suryoday 6:36 AM (DrikPanchang)." },
  ],
  schemaName: "Chhath Puja 2027 Dates",
  schemaDescription:
    "Chhath Puja 2027: Nahay Khay on 2 November, Kharna on 3 November, Sandhya Arghya on Thursday, 4 November and Usha Arghya on Friday, 5 November, with New Delhi sunrise and sunset per DrikPanchang.",
  finalHeading: "Surya upasana, apne chart ke saath",
  finalText: "Free kundli me dekhiye Surya aapke kis ghar me hai aur kya phal deta hai.",
  disclaimer: datesDisclaimer,
  articleSection: "Festivals",
};

export const guruPurnima2027: LandingConfig = {
  url: "https://astroaura.ai/guru-purnima-2027",
  wide: true,
  title: "Guru Purnima 2027 Kab Hai: Date Aur Tithi | Aura AI",
  description:
    "Guru Purnima 2027 Sunday, 18 July ko hai, Ashadha Purnima par. Purnima tithi 17 July shaam se 18 July raat tak; Vyas Puja ka mahatva aur date ka hisaab yahan.",
  eyebrow: "Guru Purnima 2027",
  h1Pre: "Guru Purnima 2027:",
  h1Accent: "Sunday, 18 July",
  sub: "Guru aur Maharshi Ved Vyas ko samarpit din, is baar Sunday ko. Ashadha Purnima ki tithi aur date kaise nikalti hai, neeche.",
  primaryCta: "Apna free kundli banaiye",
  secondaryCta: "Panchang dekhiye",
  lede: [
    "Guru Purnima 2027 Sunday, 18 July 2027 ko hai. Yeh Ashadha month ki Purnima ko manayi jaati hai, aur ise Vyas Purnima bhi kehte hain, kyunki is din Maharshi Ved Vyas ka janm maana gaya hai. DrikPanchang ke anusaar Purnima tithi Saturday, 17 July ko 6:48 PM se Sunday, 18 July ko 9:14 PM tak (New Delhi) rahegi.",
  ],
  heroFacts: ["Sunday, 18 Jul 2027", "Ashadha Purnima", "Vyas Purnima"],
  sections: [
    {
      h2: "Guru Purnima 2027: tithi (New Delhi)",
      table: {
        head: ["Vivaran", "Samay (New Delhi)"],
        rows: [
          ["Purnima tithi shuru", "6:48 PM, Saturday, 17 July"],
          ["Purnima tithi samaapt", "9:14 PM, Sunday, 18 July"],
          ["Guru Purnima", "Sunday, 18 July"],
        ],
        caption: "Tithi ka samay DrikPanchang ke anusaar, New Delhi ke liye.",
      },
      body: [
        "Guru Purnima udaya tithi se manayi jaati hai: 18 July ke suryoday par Purnima maujood hai aur poore din rehti hai, isliye DrikPanchang aur DekhoPanchang dono 18 July dete hain. Kuchh calendar 17 July bhi likhte hain kyunki tithi us shaam shuru ho jaati hai; guru puja ka din 18 July hi hai.",
      ],
      chips: planChips,
    },
    {
      h2: "Guru puja kaise karein",
      steps: [
        "Subah snan ke baad apne guru, ya guru ke chitra, ko pranaam aur pushp arpan.",
        "Ved Vyas ji ka smaran aur Vyas Puja.",
        "Guru ko dakshina ya bhent, aur unka aashirvaad.",
      ],
      body: [
        "Is din se Chaturmas ka samay bhi chal raha hota hai, jab saadhu-sant ek jagah reh kar saadhana karte hain. Kai log Guru Purnima par naya adhyayan ya mantra-deeksha shuru karte hain.",
      ],
    },
    {
      h2: "Jyotish me guru: Brihaspati",
      body: [
        "Jyotish me Guru yaani Brihaspati gyaan, vivaah aur bhagya ke karak hain. Aapki kundli me Guru kis ghar aur rashi me hai, yeh jaanne ke liye free kundli banaiye.",
      ],
    },
  ],
  faqs: [
    { q: "Guru Purnima 2027 kab hai?", a: "Sunday, 18 July 2027 ko, Ashadha Purnima par." },
    { q: "Purnima tithi kab se kab tak hai?", a: "DrikPanchang ke anusaar 17 July ko 6:48 PM se 18 July ko 9:14 PM tak (New Delhi)." },
    { q: "Guru Purnima ko Vyas Purnima kyun kehte hain?", a: "Kyunki is din Maharshi Ved Vyas ka janm maana jaata hai, jinhone Vedon ka vibhajan kiya aur Mahabharat ki rachna ki." },
  ],
  schemaName: "Guru Purnima 2027 Date",
  schemaDescription:
    "Guru Purnima 2027 is on Sunday, 18 July (Ashadha Purnima). Purnima tithi runs from 6:48 PM on 17 July to 9:14 PM on 18 July in New Delhi per DrikPanchang.",
  finalHeading: "Apne chart ka Guru janiye",
  finalText: "Free kundli me dekhiye Brihaspati aapke kis ghar me hai aur kya deta hai.",
  disclaimer: datesDisclaimer,
  articleSection: "Festivals",
};

export const akshayaTritiya2027: LandingConfig = {
  url: "https://astroaura.ai/akshaya-tritiya-2027",
  wide: true,
  title: "Akshaya Tritiya 2027 Kab Hai: 8 Ya 9 May? | Aura AI",
  description:
    "Akshaya Tritiya 2027 DrikPanchang ke anusaar Sunday, 9 May ko hai; kuchh panchang 8 May dete hain. Puja muhurat, sona kharidne ka samay aur tithi yahan.",
  eyebrow: "Akshaya Tritiya 2027",
  h1Pre: "Akshaya Tritiya 2027:",
  h1Accent: "Sunday, 9 May",
  sub: "Akha Teej Vaishakha Shukla Tritiya ko: 2027 me tithi 8 May ki dopahar shuru hokar 9 May ki subah khatam hoti hai, isliye dono dates chapti hain.",
  primaryCta: "Apna free kundli banaiye",
  secondaryCta: "Panchang dekhiye",
  lede: [
    "Akshaya Tritiya 2027 ke liye DrikPanchang aur BhaktiBharat Sunday, 9 May 2027 dete hain. Tritiya tithi Saturday, 8 May ko 11:42 AM par shuru hoti hai aur Sunday, 9 May ko 9:03 AM par khatam (New Delhi). Kuchh panchang, jaise DekhoPanchang, madhyahna-niyam se Saturday, 8 May likhte hain. Sona kharidne ke liye DrikPanchang dono dinon ka window deta hai.",
  ],
  heroFacts: ["Sun, 9 May 2027 (DrikPanchang)", "Vaishakha Shukla Tritiya", "Puja: 5:35 AM se 9:03 AM (Delhi)"],
  sections: [
    {
      h2: "Akshaya Tritiya 2027: muhurat (New Delhi)",
      table: {
        head: ["Vivaran", "Samay (New Delhi)"],
        rows: [
          ["Tritiya tithi shuru", "11:42 AM, Saturday, 8 May"],
          ["Tritiya tithi samaapt", "9:03 AM, Sunday, 9 May"],
          ["Puja muhurat", "5:35 AM se 9:03 AM, 9 May"],
          ["Sona kharidne ka samay (8 May)", "11:42 AM, 8 May se 5:35 AM, 9 May"],
          ["Sona kharidne ka samay (9 May)", "5:35 AM se 9:03 AM"],
        ],
        caption:
          "Samay DrikPanchang ke anusaar, New Delhi ke liye. Doosre sheher ka samay panchang par dekhiye.",
      },
      chips: planChips,
    },
    {
      h2: "8 ya 9 May: antar kyun dikhta hai",
      body: [
        "Akshaya Tritiya ka din is baat se tay hota hai ki Tritiya tithi din ke kis hisse me maujood hai. DrikPanchang ke hisaab se 9 May ki subah, purvahna me Tritiya hai, isliye woh 9 May deta hai. DekhoPanchang madhyahna (dopahar) ka niyam lagata hai: 8 May ki dopahar Tritiya shuru ho chuki hai, isliye uska jawaab 8 May hai.",
        "Vyavahaar me iska matlab yeh hai ki puja ke liye 9 May ki subah 9:03 AM se pehle ka samay sabse surakshit hai, aur sona-chandi ki kharid Tritiya tithi ke dauraan, 8 May dopahar se 9 May subah tak, ki ja sakti hai. Apni parampara ke anusaar sthaniya panchang se confirm kijiye.",
      ],
    },
    {
      h2: "Abujh muhurat: kya shuru karein",
      body: [
        "Akshaya Tritiya saal ke abujh muhuraton me se ek hai: is din kiya gaya daan, japa aur nivesh 'akshaya', yaani kabhi kshay na hone wala maana jaata hai. Sona kharidna, griha pravesh, vivaah aur naya vyapaar is din parampara se kiye jaate hain. Bade aarthik faisle ke liye apni dasha bhi dekhiye; free kundli me turant milti hai.",
      ],
    },
  ],
  faqs: [
    { q: "Akshaya Tritiya 2027 kab hai?", a: "DrikPanchang ke anusaar Sunday, 9 May 2027. Kuchh panchang madhyahna-niyam se Saturday, 8 May dete hain." },
    { q: "Akshaya Tritiya 2027 ka puja muhurat kya hai?", a: "New Delhi me 5:35 AM se 9:03 AM, 9 May 2027 (DrikPanchang)." },
    { q: "Sona kab kharidein?", a: "Tritiya tithi ke dauraan: 8 May ko 11:42 AM se 9 May ko 9:03 AM tak (New Delhi, DrikPanchang)." },
  ],
  schemaName: "Akshaya Tritiya 2027 Date",
  schemaDescription:
    "Akshaya Tritiya 2027 is on Sunday, 9 May per DrikPanchang, with puja muhurat 5:35 AM to 9:03 AM in New Delhi; some panchangs list 8 May. Tritiya tithi and gold buying window.",
  finalHeading: "Akshaya nivesh, apne chart ke saath",
  finalText: "Free kundli banaiye aur bade faisle apni dasha ke hisaab se kijiye.",
  disclaimer: datesDisclaimer,
  articleSection: "Festivals",
};

export const ramNavami2027: LandingConfig = {
  url: "https://astroaura.ai/ram-navami-2027",
  wide: true,
  title: "Ram Navami 2027 Kab Hai: Date Aur Puja Muhurat | Aura AI",
  description:
    "Ram Navami 2027 Thursday, 15 April ko hai, Chaitra Shukla Navami par. Madhyahna puja muhurat, Navami tithi ka samay aur Chaitra Navratri ki dates yahan.",
  eyebrow: "Ram Navami 2027",
  h1Pre: "Ram Navami 2027:",
  h1Accent: "Thursday, 15 April",
  sub: "Shri Ram janmotsav madhyahna me: 2027 me Navami tithi 14 April dopahar se 15 April dopahar tak hai, aur Chaitra Navratri isi din poori hoti hai.",
  primaryCta: "Apna free kundli banaiye",
  secondaryCta: "Panchang dekhiye",
  lede: [
    "Ram Navami 2027 Thursday, 15 April 2027 ko hai. Yeh Chaitra Shukla Navami ka parv hai, aur Shri Ram ka janm madhyahna (dopahar) me maana gaya hai, isliye puja usi samay hoti hai. DrikPanchang ke anusaar New Delhi me madhyahna puja muhurat 11:04 AM se 1:38 PM tak hai, aur Chaitra Navratri (7 April se) isi din poori hoti hai.",
  ],
  heroFacts: ["Thursday, 15 Apr 2027", "Chaitra Shukla Navami", "Madhyahna: 11:04 AM se 1:38 PM (Delhi)"],
  sections: [
    {
      h2: "Ram Navami 2027: tithi aur muhurat (New Delhi)",
      table: {
        head: ["Vivaran", "Samay (New Delhi)"],
        rows: [
          ["Navami tithi shuru", "3:23 PM, Wednesday, 14 April"],
          ["Navami tithi samaapt", "1:20 PM, Thursday, 15 April"],
          ["Madhyahna puja muhurat", "11:04 AM se 1:38 PM, 15 April"],
          ["Madhyahna kshan", "12:21 PM"],
        ],
        caption:
          "Samay DrikPanchang ke anusaar, New Delhi ke liye. DekhoPanchang bhi Delhi ke liye yahi window deta hai.",
      },
      body: [
        "Dhyaan dijiye: Navami tithi 15 April ko 1:20 PM par khatam hoti hai, jabki madhyahna window 1:38 PM tak hai. Tithi ke bhitar puja karni ho to 12:21 PM ka madhyahna kshan aur 1:20 PM se pehle ka samay sabse uchit hai.",
      ],
      chips: planChips,
    },
    {
      h2: "Date kaise tay hoti hai",
      body: [
        "Ram Navami us din manayi jaati hai jab madhyahna me Navami tithi maujood ho. 2027 me Navami 14 April ki dopahar 3:23 PM par shuru hoti hai, yaani 14 April ka madhyahna nikal chuka hota hai; 15 April ka madhyahna Navami me padta hai. Isliye India ke panchang 15 April par sehmat hain.",
        "Videsh me time zone ke kaaran kuchh jagah (jaise US ke kai sheher) Ram Navami 14 April ko padti hai. Wahan apne sheher ka local panchang dekhiye.",
      ],
    },
    {
      h2: "Chaitra Navratri 2027 ke saath",
      body: [
        "Chaitra Navratri 7 April 2027 se shuru hoti hai aur Ram Navami par nau din poore hote hain. Kai parivaar is din kanya pujan aur Navratri vrat ka paaran karte hain. Sharad Navratri 2027 ki dates ke liye humara Navratri 2027 page dekhiye.",
      ],
    },
  ],
  faqs: [
    { q: "Ram Navami 2027 kab hai?", a: "Thursday, 15 April 2027 ko, Chaitra Shukla Navami par." },
    { q: "Ram Navami 2027 ka puja muhurat kya hai?", a: "DrikPanchang ke anusaar New Delhi me madhyahna muhurat 11:04 AM se 1:38 PM, madhyahna kshan 12:21 PM." },
    { q: "Navami tithi kab tak hai?", a: "14 April ko 3:23 PM se 15 April ko 1:20 PM tak (New Delhi, DrikPanchang)." },
  ],
  schemaName: "Ram Navami 2027 Date",
  schemaDescription:
    "Ram Navami 2027 is on Thursday, 15 April (Chaitra Shukla Navami), with Madhyahna puja muhurat 11:04 AM to 1:38 PM in New Delhi per DrikPanchang.",
  finalHeading: "Navratri ki saadhana, apne chart ke saath",
  finalText: "Free kundli banaiye aur vrat-tyohaar apne grahon ke hisaab se plan kijiye.",
  disclaimer: datesDisclaimer,
  relatedLinks: [{ to: "/navratri-2027", label: "Navratri 2027" }],
  articleSection: "Festivals",
};

export const basantPanchami2027: LandingConfig = {
  url: "https://astroaura.ai/basant-panchami-2027",
  wide: true,
  title: "Basant Panchami 2027 Kab Hai: Saraswati Puja Date | Aura AI",
  description:
    "Basant Panchami 2027 Thursday, 11 February ko hai. Saraswati Puja muhurat 7:03 AM se 12:36 PM (New Delhi), Magha Shukla Panchami ki tithi aur niyam yahan.",
  eyebrow: "Basant Panchami 2027",
  h1Pre: "Basant Panchami 2027:",
  h1Accent: "Thursday, 11 February",
  sub: "Maa Saraswati ki puja aur basant ritu ka aagman, is baar Thursday ko. Purvahna me puja ka samay aur tithi neeche.",
  primaryCta: "Apna free kundli banaiye",
  secondaryCta: "Panchang dekhiye",
  lede: [
    "Basant Panchami (Vasant Panchami) 2027 Thursday, 11 February 2027 ko hai. Yeh Magha Shukla Panchami ka parv hai, jis din Maa Saraswati ki puja hoti hai. DrikPanchang ke anusaar New Delhi me Saraswati Puja muhurat 7:03 AM se 12:36 PM tak hai, aur Panchami tithi 11 February ko 3:04 AM se 12 February ko 3:18 AM tak rahegi.",
  ],
  heroFacts: ["Thursday, 11 Feb 2027", "Magha Shukla Panchami", "Puja: 7:03 AM se 12:36 PM (Delhi)"],
  sections: [
    {
      h2: "Basant Panchami 2027: tithi aur muhurat (New Delhi)",
      table: {
        head: ["Vivaran", "Samay (New Delhi)"],
        rows: [
          ["Panchami tithi shuru", "3:04 AM, Thursday, 11 February"],
          ["Panchami tithi samaapt", "3:18 AM, Friday, 12 February"],
          ["Saraswati Puja muhurat", "7:03 AM se 12:36 PM, 11 February"],
          ["Madhyahna kshan", "12:36 PM"],
        ],
        caption:
          "Samay DrikPanchang ke anusaar, New Delhi ke liye. Doosre sheher ka samay panchang par dekhiye.",
      },
      body: [
        "2027 me Panchami tithi 11 February ke suryoday se pehle shuru hokar poore din rehti hai, isliye date par koi confusion nahi: DrikPanchang aur DekhoPanchang dono 11 February dete hain. Puja purvahna (suryoday se dopahar tak) me ki jaati hai.",
      ],
      chips: planChips,
    },
    {
      h2: "Saraswati Puja aur vidya-aarambh",
      steps: [
        "Peele vastra, peele phool aur peele prasad se Maa Saraswati ki puja.",
        "Kitaabon, kalam aur vaadya-yantron ko Maa ke saamne rakh kar aashirvaad.",
        "Chhote bachchon ka vidya-aarambh (akshar abhyas) is din shubh maana jaata hai.",
      ],
      body: [
        "Basant Panchami ko bhi abujh muhurat maana jaata hai, isliye vivaah aur naye kaam ke liye yeh lokpriya din hai. Students ke liye yeh padhai ka naya sankalp lene ka din hai.",
      ],
    },
    {
      h2: "Jyotish me vidya ke grah",
      body: [
        "Kundli me Budh buddhi aur Guru gyaan ke karak hain, aur paanchva ghar shiksha ka. Bachche ki padhai ya career ki disha samajhni ho to free kundli me in grahon ki sthiti dekhiye.",
      ],
    },
  ],
  faqs: [
    { q: "Basant Panchami 2027 kab hai?", a: "Thursday, 11 February 2027 ko, Magha Shukla Panchami par." },
    { q: "Saraswati Puja 2027 ka muhurat kya hai?", a: "DrikPanchang ke anusaar New Delhi me 7:03 AM se 12:36 PM, 11 February 2027." },
    { q: "Panchami tithi kab tak hai?", a: "11 February ko 3:04 AM se 12 February ko 3:18 AM tak (New Delhi, DrikPanchang)." },
  ],
  schemaName: "Basant Panchami 2027 Date",
  schemaDescription:
    "Basant (Vasant) Panchami 2027 is on Thursday, 11 February (Magha Shukla Panchami), with Saraswati Puja muhurat 7:03 AM to 12:36 PM in New Delhi per DrikPanchang.",
  finalHeading: "Vidya aur gyaan, apne chart se",
  finalText: "Free kundli me dekhiye Budh aur Guru aapke chart me kahan hain.",
  disclaimer: datesDisclaimer,
  articleSection: "Festivals",
};

export const festivalPages2027: { path: string; config: LandingConfig }[] = [
  { path: "/diwali-2027", config: diwali2027 },
  { path: "/holi-2027", config: holi2027 },
  { path: "/raksha-bandhan-2027", config: rakshaBandhan2027 },
  { path: "/navratri-2027", config: navratri2027 },
  { path: "/maha-shivratri-2027", config: mahaShivratri2027 },
  { path: "/janmashtami-2027", config: janmashtami2027 },
  { path: "/makar-sankranti-2027", config: makarSankranti2027 },
  { path: "/karwa-chauth-2027", config: karwaChauth2027 },
  { path: "/ganesh-chaturthi-2027", config: ganeshChaturthi2027 },
  { path: "/dussehra-2027", config: dussehra2027 },
  { path: "/chhath-puja-2027", config: chhathPuja2027 },
  { path: "/guru-purnima-2027", config: guruPurnima2027 },
  { path: "/akshaya-tritiya-2027", config: akshayaTritiya2027 },
  { path: "/ram-navami-2027", config: ramNavami2027 },
  { path: "/basant-panchami-2027", config: basantPanchami2027 },
];
